import React, { useRef, useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";

export default function ToolTip({ children, text, direction = "top" }) {
  const wrapperRef = useRef(null);
  const tooltipRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const calculatePosition = useCallback(() => {
    if (wrapperRef.current && tooltipRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();

      const left = rect.left + rect.width / 2 - tooltipRect.width / 2;
      let top = 0;

      if (direction === "top") {
        top = rect.top - tooltipRect.height - 8;
      } else {
        top = rect.bottom + 8;
      }

      setPosition({ top, left });
    }
  }, [direction]);

  useEffect(() => {
    if (isHovered) {
      calculatePosition();

      window.addEventListener("scroll", calculatePosition, true);
      window.addEventListener("resize", calculatePosition);

      return () => {
        window.removeEventListener("scroll", calculatePosition, true);
        window.removeEventListener("resize", calculatePosition);
      };
    }
  }, [isHovered, calculatePosition]);

  return (
    <div
      ref={wrapperRef}
      className="relative inline-block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}

      {isHovered && createPortal(
        <div
          ref={tooltipRef}
          className={`fixed z-70 w-max max-w-xs bg-white border-2 border-gray-200 rounded-xl shadow-lg p-3 text-sm text-gray-600 pointer-events-none transition-opacity duration-200`}
          style={{
            top: position.top,
            left: position.left,
          }}
        >
          {text}
        </div>,
        document.body
      )}
    </div>
  );
}
